import { Injectable } from '@angular/core';
import { environment } from '../../environments';

@Injectable({
  providedIn: 'root'
})
export class MVLocalStorageService {

    static getItem(key): any {
        return localStorage.getItem(environment.appKey + "_" + key);
    }
    static setItem(key, value){
        localStorage.setItem(environment.appKey + "_" + key, value);
    }
    static removeItem(key){
        localStorage.removeItem(environment.appKey + "_" + key);
    }
     // tslint:disable-next-line: no-any
     static getSessionItem(key): any {
        return sessionStorage.getItem(environment.appKey + '_' + key);
    }
    static setSessionItem(key, value) {
        sessionStorage.setItem(environment.appKey + '_' + key, value);
    }
    static removeSessionItem(key) {
        sessionStorage.removeItem(environment.appKey + '_' + key);
    }

}
